import { render } from "./DeleteDialog.vue?vue&type=template&id=0d84784e"
import script from "./js/deleteDialog.js?vue&type=script&lang=js&external"
export * from "./js/deleteDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__